export default {
  language: {
    label: "Language",
    search: "Search language",
    // The languages listed in `plugins/i18n/locales.js` that have no message bundle yet.
    comingSoon: "Coming soon",
    noResults: "No language found.",
  },
  profile: "My Profile",
  // Only shown to somebody who belongs to more than one workspace. That the entry signs you out is
  // left to the login form to say (`auth.login.switch_workspace`).
  switchWorkspace: "Switch workspace",
  theme: {
    label: "Appearance",
    // "System" follows the operating system setting and switches along with it.
    system: "System",
    light: "Light",
    dark: "Dark",
  },
  help: {
    label: "Help",
    tour: "Start tour",
    releaseNotes: "What's new",
    support: "Contact support",
    reportBug: "Report a bug",
  },
}
